export const introduce = {
  text: '持币余额 < 1 的地址数量',
  height: 1200,
};
